import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      es: {
        translation: {
          noCreditsLeft: "No tienes créditos disponibles",
          login: "Iniciar sesión",
          sendingData: "Enviando datos",
          notObjectProcessed: "No se han podido procesar los siguientes objetos:\n",
          company: "Compañía",
          contact: "Contacto",
          deal: "Negocio",
          task: "Tarea",
          meeting: "Reunión",
          mail: "Correo",
          contacts: "Contactos",
          note: "Nota",
          call: "Llamada",
          pipeline: "Pipeline",
          pipelineStages: "Etapas",
          other: "Otro",
          selectPipeline: "Seleccione un pipeline",
          selectPipelineStage: "Seleccione una etapa",
          selectCompany: "Valide los datos de la compañía",
          selectContact: "Valide los datos del contacto",
          selectTask: "Valide los datos de la tarea",
          selectMeeting: "Valide los datos de la reunión",
          selectMail: "Valide los datos del correo",
          selectNote: "Valide los datos de la nota",
          selectCall: "Valide los datos de la llamada",
          selectDeal: "Valide los datos del negocio",
          tasks: "Tareas",
          next: "Siguiente",
          finish: "Finalizar",
          cancel: "Cancelar",
          cancelConfirmation: "¿Estás seguro de que quieres cancelar?",
          close: "Cerrar",
          ok: "Ok",
          errorProcessingRequest: "Error al procesar la solicitud",
          errorProcessingRequestDescription: "Inténtelo de nuevo.",
          processingAudio: "Procesando audio",
          minutesSaved: "Has ahorrado",
          minutes: "minutos",
          savedIn: "en",
          audioSentCorrectly: "Audio enviado correctamente",
          retry: "Reintentar",
          dateTime: "Fecha y hora",
          duration: "Duración",
          disposition: "Resultado",
          busy: "Ocupado",
          connected: "Conectado",
          noResponse: "No respondió",
          wrongNumber: "Número incorrecto",
          voiceMessage: "Dejó mensaje de voz",
          liveMessage: "Dejó mensaje en vivo",
          direction: "Dirección",
          inbound: "ENTRANTE",
          outbound: "SALIENTE",
          title: "Título",
          audioText: "Pulsa para grabar",
          description: "Descripción",
          associations: "Asociaciones",
          companies: "Empresas",
          deals: "Negocios",
          companyName: "Nombre de la compañía",
          companyDomain: "Dominio de la compañía",
          selectCompany: "Selecciona una compañía",
          createCompany: "Crear compañía",
          errorSendingAudio: "Error al enviar el audio",
          createCompanyDescription: "Crea una nueva compañía",
          userAlreadyExists: "Sucedió un error, por favor compruebe los datos y vuelva a intentarlo",
          name: "Nombre",
          lastName: "Apellidos",
          email: "Email",
          phoneNumber: "Teléfono",
          selectContact: "Selecciona un contacto",
          createContact: "Crear contacto",
          dealName: "Nombre del negocio",
          dealValue: "Valor del negocio",
          dealClose: "Fecha de cierre del negocio",
          selectDeal: "Selecciona un negocio",
          recipients: "Destinatarios",
          subject: "Asunto",
          message: "Mensaje",
          meetingTitle: "Título de la reunión",
          meetingStartDate: "Fecha de inicio",
          meetingEndDate: "Fecha de finalización",
          meetingLocation: "Lugar",
          meetingReminder: "Recordatorio",
          meetingDescription: "Descripción",
          meetingInternalNote: "Nota interna",
          low: "Baja",
          medium: "Media",
          high: "Alta",
          dueDate: "Fecha de vencimiento",
          hsTaskType: "Tipo de tarea",
          call: "Llamada",
          email: "Correo electrónico",
          todo: "Tarea",
          crmUpdated: "CRM actualizado correctamente",
          domain: "Dominio",
          phone: "Teléfono",
          address: "Dirección",
          audioCompanyText: "Pulsa para grabar acciones sobre esta compañía",
          errorMovingDeal: "Error al mover el negocio. Por favor, inténtalo de nuevo más tarde.",
          selectStage: "Selecciona a que etapa del pipeline quieres pasar este negocio.",
          moveDeal: "Mover a otra etapa",
          save: "Guardar",
          stage: "Etapa",
          amount: "Importe",
          closedate: "Fecha de cierre",
          createdate: "Fecha de creación",
          audioContactText: "Pulsa para grabar acciones sobre este contacto",
          record: "Grabar",
          account: "Cuenta",
          recording: "Grabando audio...",
          paused: "Pausado",
          microphone: "Micrófono",
          recordingCancelled: "Grabación cancelada",
          search: "Buscar",
          min: "min",
          sortBy: "Ordenar por",
          newest: "Más nuevo",
          oldest: "Más antiguo",
          disconnectGmail: "Desconectar Gmail",
          logout: "Cerrar sesión",
          connectGmail: "Conectar Gmail",
          gmailConnected: "Gmail conectado correctamente",
          gmailDisconnected: "Gmail desconectado correctamente",
          attendees: "Asistentes",
          properties: "Propiedades",
          select_properties: "Seleccione propiedades",
          propertyToUpdate: "Propiedad a actualizar",
          selectProperty: "Seleccione propiedades",
          updateProperties: "Actualizar propiedades",
          propertiesUpdated: "Propiedades actualizadas correctamente",
          propertiesUpdatedError: "Error al actualizar las propiedades",
          createGoogleMeet: "Enviar enlace de Google Meet",
          createMeeting: "Enviar convocatoria de reunión al cliente",
          completed: "Completado",
          not_started: "No iniciado",
          none: "Sin prioridad",
          reminders: "Recordatorios",
          nearest: "Más próximo",
          farthest: "Más lejano",
          updateTask: "Actualizar tarea",
          status: "Estado",
          notStarted: "No iniciado",
          inProgress: "En progreso",
          errorUpdatingTask: "Error al actualizar la tarea",
          priority: "Prioridad",
          type: "Tipo",
          identifyingActions: "Identificando acciones",
          welcomeToLabia: "Bienvenido a Labia",
          onboardingDescription: "Descubre lo que puedes hacer con Labia a través de estos ejemplos. ¡Haz clic en 'Pruébalo' para ver cómo funciona!",
          example: "Ejemplo",
          tryIt: "Pruébalo",
          showMore: "Mostrar más",
          showLess: "Mostrar menos",
          learnToUseLabia: "Pincha aquí",
          onboarding: "¿Quieres aprender a usar Labia?",
          onboardingExamples: {
            contactAndCompany: {
              title: "Crear Contactos y Empresas",
              description: "Crea fácilmente nuevos contactos y empresas con todos sus detalles en lenguaje natural.",
              example: "Labia, creame un contacto llamado Daniel Rodriguez de la empresa Labia con el email dani@labia.pro y el teléfono 678368027. Crea la compañía Labia con el dominio labia.pro",
            },
            dealsPipeline: {
              title: "Crear Negocios en el pipeline de ventas",
              description: "Crea negocios en el pipeline de ventas para hacer seguimiento de la información importante.",
              example: "Crea un negocio por valor de 5000 euros con el nombre \"Paquete 100 unidades\" y una fecha de cierre estimada para el 20 de junio.",
            },
            tasksAndNotes: {
              title: "Crear Tareas y Notas",
              description: "Programa tareas y añade notas para hacer seguimiento de información importante y cerrar más ventas.",
              example: "Busca al contacto Daniel Rodríguez y crea una tarea para llamarle el viernes a las 10 de la mañana para comprobar si ha podido ver nuestro catálogo y nuestra oferta. Crea además una nota interna exponiendo que es el director de compras, es celíaco  y le gusta el Real Madrid."
            },
            email: {
              title: "Enviar emails",
              description: "Envía Emails personalizados y con el tono de tu empresa",
              example: "Envíale un email a Daniel Rodríguez con tono emocionado diciendo que ya he probado Labia, me ha parecido increíble y me ahorrará mucho tiempo, añádele iconos."
            },
            meeting: {
              title: "Agenda reuniones",
              description: "Agenda reuniones con clientes y enviales la convocatoria de la reunión",
              example: "Agenda una reunión con Daniel Rodríguez para el 15 de junio a las 12  en sus oficinas de Madrid con el Asunto: \"Reunión Demo\", donde hablaremos sobre nuestro nuevo producto."
            },
            call: {
              title: "Llamadas",
              description: "Registra llamadas con el resumen de lo conversado con el cliente",
              example: "Registra una llamada con el contacto Daniel Rodríguez hace 10 minutos donde hemos hablado sobre el presupuesto que le ha enviado la competencia y me ha comentado que si le hacemos un 10% de descuento lo firma esta misma tarde."
            },
            allInOne: {
              title: "Todas las acciones en una sola instrucción",
              description: "Crea un contacto, una tarea, una nota y un email con una sola instrucción.",
              example: "Creame un contacto llamado Carmen Rodriguez Pérez de la empresa CRM con el email carmen@crm.com y el teléfono 611223344. Crea la compañía CRM con el dominio CRM.com\n\nCrea una tarea para llamarle el viernes a las 10 de la mañana y comentarle que ya he aumentado mis ventas gracias a la mejor gestión del CRM.\n\nCrea además una nota interna del contacto exponiendo que es la directora de la empresa y es la encargada de recibir sugerencias de los clientes.\n\nPor último, envíale un email con tono emocionado diciendo que ya he probado su herramienta, me ha parecido increíble y me ahorrará mucho tiempo, añádele iconos."
            }
          },
          audioHistory: "Historial",
          loading: "Cargando...",
          noAudioHistory: "No hay historial de audio disponible",
          selectCamera: "Seleccionar cámara",
          capturePhoto: "Capturar foto",
          capturing: "Capturando...",
          errorProcessingPhoto: "Error al procesar la foto",
          ocrResult: "Texto detectado",
          ocr: "Escanear documento",
          businessCard: "Escanear tarjeta de visita"
        }
      },
      pt: {
        translation: {
          noCreditsLeft: "Sem créditos disponíveis",
          login: "Iniciar sessão",
          sendingData: "Enviando dados",
          notObjectProcessed: "Não foi possível processar os seguintes objetos:\n",
          audioText: "Pulsa para gravar",
          company: "Empresa",
          contact: "Contato",
          contacts: "Contactos",
          deal: "Negócio",
          task: "Tarefa",
          meeting: "Reunião",
          mail: "E-mail",
          note: "Nota",
          call: "Chamada",
          pipeline: "Pipeline",
          pipelineStages: "Etapas",
          other: "Outro",
          tasks: "Tarefas",
          selectPipeline: "Selecione um pipeline",
          selectPipelineStage: "Selecione uma etapa",
          selectCompany: "Valide os dados da empresa",
          selectContact: "Valide os dados do contato",
          selectTask: "Valide os dados da tarefa",
          selectMeeting: "Valide os dados da reunião",
          selectMail: "Valide os dados do e-mail",
          selectNote: "Valide os dados da nota",
          selectCall: "Valide os dados da chamada",
          selectDeal: "Valide os dados do negócio",
          next: "Próximo",
          finish: "Finalizar",
          cancel: "Cancelar",
          cancelConfirmation: "Tem certeza que deseja cancelar?",
          close: "Fechar",
          ok: "Ok",
          errorProcessingRequest: "Erro ao processar a solicitação",
          errorProcessingRequestDescription: "Tente novamente.",
          errorSendingAudio: "Erro ao enviar o áudio",
          processingAudio: "Processando áudio",
          minutesSaved: "Você economizou",
          minutes: "minutos",
          min: "min",
          savedIn: "em",
          audioSentCorrectly: "Áudio enviado corretamente",
          retry: "Tentar novamente",
          dateTime: "Data e hora",
          duration: "Duração",
          disposition: "Resultado",
          busy: "Ocupado",
          connected: "Conectado",
          noResponse: "Sem resposta",
          wrongNumber: "Número incorreto",
          voiceMessage: "Deixou mensagem de voz",
          liveMessage: "Deixou mensagem ao vivo",
          direction: "Direção",
          inbound: "ENTRADA",
          outbound: "SAÍDA",
          title: "Título",
          description: "Descrição",
          associations: "Associações",
          companies: "Empresas",
          deals: "Negócios",
          companyName: "Nome da empresa",
          companyDomain: "Domínio da empresa",
          selectCompany: "Selecione uma empresa",
          createCompany: "Criar empresa",
          createCompanyDescription: "Crie uma nova empresa",
          userAlreadyExists: "Ocorreu um erro, por favor verifique os dados e tente novamente",
          name: "Nome",
          lastName: "Sobrenome",
          email: "E-mail",
          phoneNumber: "Telefone",
          selectContact: "Selecione um contato",
          createContact: "Criar contato",
          dealName: "Nome do negócio",
          dealValue: "Valor do negócio",
          dealClose: "Data de fechamento do negócio",
          selectDeal: "Selecione um negócio",
          recipients: "Destinatários",
          subject: "Assunto",
          message: "Mensagem",
          meetingTitle: "Título da reunião",
          meetingStartDate: "Data de início",
          meetingEndDate: "Data de término",
          meetingLocation: "Local",
          meetingReminder: "Lembrete",
          meetingDescription: "Descrição",
          meetingInternalNote: "Nota interna",
          low: "Baixa",
          medium: "Média",
          high: "Alta",
          dueDate: "Data de vencimento",
          hsTaskType: "Tipo de tarefa",
          call: "Chamada",
          email: "E-mail",
          todo: "Tarefa",
          crmUpdated: "CRM atualizado corretamente",
          domain: "Domínio",
          phone: "Telefone",
          address: "Endereço",
          audioCompanyText: "Clique para gravar ações sobre esta empresa",
          errorMovingDeal: "Erro ao mover o negócio. Por favor, tente novamente mais tarde.",
          selectStage: "Selecione para qual etapa do pipeline você quer mover este negócio.",
          moveDeal: "Mover para outra etapa",
          save: "Salvar",
          stage: "Etapa",
          amount: "Valor",
          closedate: "Data de fechamento",
          createdate: "Data de criação",
          audioContactText: "Clique para gravar ações sobre este contato",
          record: "Gravar",
          account: "Conta",
          recording: "Gravando áudio...",
          paused: "Pausado",
          microphone: "Microfone",
          recordingCancelled: "Gravação cancelada",
          search: "Buscar",
          sortBy: "Ordenar por",
          newest: "Mais recente",
          oldest: "Mais antigo",
          disconnectGmail: "Desconectar Gmail",
          logout: "Sair",
          connectGmail: "Conectar Gmail",
          gmailConnected: "Gmail conectado corretamente",
          gmailDisconnected: "Gmail desconectado corretamente",
          attendees: "Participantes",
          properties: "Propriedades",
          select_properties: "Selecione propriedades",
          propertyToUpdate: "Propriedade a atualizar",
          selectProperty: "Selecione propriedades",
          updateProperties: "Atualizar propriedades",
          propertiesUpdated: "Propriedades atualizadas corretamente",
          propertiesUpdatedError: "Erro ao atualizar as propriedades",
          createGoogleMeet: "Enviar link do Google Meet",
          createMeeting: "Enviar convite de reunião ao cliente",
          not_started: "Não iniciado",
          none: "Sem prioridade",
          reminders: "Lembretes",
          nearest: "Mais próximo",
          farthest: "Mais distante",
          updateTask: "Atualizar tarefa",
          status: "Status",
          notStarted: "Não iniciado",
          inProgress: "Em andamento",
          completed: "Completado",
          errorUpdatingTask: "Erro ao atualizar a tarefa",
          priority: "Prioridade",
          type: "Tipo",
          identifyingActions: "Identificando ações",
          welcomeToLabia: "Bem-vindo ao Labia",
          onboardingDescription: "Descubra o que você pode fazer com o Labia através destes exemplos. Clique em 'Experimente' para ver como funciona!",
          example: "Exemplo",
          tryIt: "Experimente",
          showMore: "Mostrar mais",
          showLess: "Mostrar menos", 
          learnToUseLabia: "Clique aqui",
          onboarding: "Quer aprender a usar o Labia?",
          onboardingExamples: {
            contactAndCompany: {
              title: "Criar Contatos e Empresas",
              description: "Crie facilmente novos contatos e empresas com todos os seus detalhes em linguagem natural.",
              example: "Labia, crie um contato chamado Daniel Rodriguez da empresa Labia com o email dani@labia.pro e o telefone 678368027. Crie a empresa Labia com o domínio labia.pro",
            },
            dealsPipeline: {
              title: "Criar Negócios no pipeline de vendas",
              description: "Crie negócios no pipeline de vendas para acompanhar as informações importantes.",
              example: "Crie um negócio no valor de 5000 euros com o nome \"Pacote 100 unidades\" e uma data de fechamento estimada para 20 de junho.",
            },
            tasksAndNotes: {
              title: "Criar Tarefas e Notas",
              description: "Agende tarefas e adicione notas para acompanhar informações importantes e fechar mais vendas.",
              example: "Procure o contato Daniel Rodríguez e crie uma tarefa para ligar para ele na sexta-feira às 10 da manhã para verificar se ele pôde ver nosso catálogo e nossa oferta. Crie também uma nota interna explicando que ele é o diretor de compras, é celíaco e torce para o Real Madrid."
            },
            email: {
              title: "Enviar emails",
              description: "Envie Emails personalizados e com o tom da sua empresa",
              example: "Envie um email para Daniel Rodríguez com tom animado dizendo que já testei o Labia, achei incrível e vai me poupar muito tempo, adicione ícones."
            },
            meeting: {
              title: "Agendar reuniões",
              description: "Agende reuniões com clientes e envie o convite da reunião",
              example: "Agende uma reunião com Daniel Rodríguez para 15 de junho às 12h no escritório dele em Madrid com o Assunto: \"Reunião Demo\", onde falaremos sobre nosso novo produto."
            },
            call: {
              title: "Chamadas",
              description: "Registre chamadas com o resumo do que foi conversado com o cliente",
              example: "Registre uma chamada com o contato Daniel Rodríguez há 10 minutos onde conversamos sobre o orçamento que a concorrência enviou e ele me disse que se dermos 10% de desconto ele assina ainda hoje."
            },
            allInOne: {
              title: "Todas as ações em uma única instrução",
              description: "Crie um contato, uma tarefa, uma nota e um email com uma única instrução.",
              example: "Crie um contato chamado Carmen Rodriguez Pérez da empresa CRM com o email carmen@crm.com e o telefone 611223344. Crie a empresa CRM com o domínio CRM.com\n\nCrie uma tarefa para ligar para ela na sexta-feira às 10 da manhã e comentar que já aumentei minhas vendas graças à melhor gestão do CRM.\n\nCrie também uma nota interna do contato explicando que ela é a diretora da empresa e é responsável por receber sugestões dos clientes.\n\nPor último, envie um email com tom animado dizendo que já testei a ferramenta dela, achei incrível e vai me poupar muito tempo, adicione ícones."
            }
          },
          audioHistory: "Histórico de áudio",
          loading: "Carregando...",
          noAudioHistory: "Não há histórico de áudio disponível",
          selectCamera: "Selecionar câmara",
          capturePhoto: "Capturar foto",
          capturing: "Capturando...",
          errorProcessingPhoto: "Erro ao processar a foto",
          ocrResult: "Texto detectado",
          ocr: "Escanear documento",
          businessCard: "Escanear cartão de visita"
        }
      },
      fr: {
        translation: {
          noCreditsLeft: "Vous n'avez plus de crédits disponibles",
          login: "Se connecter",
          sendingData: "Envoi des données",
          notObjectProcessed: "Les objets suivants n'ont pas pu être traités :\n",
          company: "Entreprise",
          contact: "Contact",
          deal: "Affaire",
          task: "Tâche",
          meeting: "Réunion",
          mail: "Courriel",
          contacts: "Contacts",
          note: "Note",
          call: "Appel",
          pipeline: "Pipeline",
          pipelineStages: "Étapes",
          other: "Autre",
          selectPipeline: "Sélectionnez un pipeline",
          selectPipelineStage: "Sélectionnez une étape",
          selectCompany: "Validez les données de l'entreprise",
          selectContact: "Validez les données du contact",
          selectTask: "Validez les données de la tâche",
          selectMeeting: "Validez les données de la réunion",
          selectMail: "Validez les données du courriel",
          selectNote: "Validez les données de la note",
          selectCall: "Validez les données de l'appel",
          selectDeal: "Validez les données de l'affaire",
          tasks: "Tâches",
          next: "Suivant",
          finish: "Terminer",
          cancel: "Annuler",
          cancelConfirmation: "Êtes-vous sûr de vouloir annuler ?",
          close: "Fermer",
          ok: "Ok",
          errorProcessingRequest: "Erreur lors du traitement de la demande",
          errorProcessingRequestDescription: "Veuillez réessayer.",
          processingAudio: "Traitement de l'audio",
          minutesSaved: "Vous avez économisé",
          minutes: "minutes",
          savedIn: "en",
          audioSentCorrectly: "Audio envoyé correctement",
          retry: "Réessayer",
          dateTime: "Date et heure",
          duration: "Durée",
          disposition: "Résultat",
          busy: "Occupé",
          connected: "Connecté",
          noResponse: "Pas de réponse",
          wrongNumber: "Numéro incorrect",
          voiceMessage: "Message vocal laissé",
          liveMessage: "Message en direct laissé",
          direction: "Direction",
          inbound: "ENTRANT",
          outbound: "SORTANT",
          title: "Titre",
          audioText: "Appuyez pour enregistrer",
          description: "Description",
          associations: "Associations",
          companies: "Entreprises",
          deals: "Affaires",
          companyName: "Nom de l'entreprise",
          companyDomain: "Domaine de l'entreprise",
          selectCompany: "Sélectionnez une entreprise",
          createCompany: "Créer une entreprise",
          createCompanyDescription: "Créez une nouvelle entreprise",
          userAlreadyExists: "Une erreur s'est produite, veuillez vérifier les données et réessayer",
          name: "Nom",
          lastName: "Nom de famille",
          email: "Email",
          phoneNumber: "Téléphone",
          selectContact: "Sélectionnez un contact",
          createContact: "Créer un contact",
          dealName: "Nom de l'affaire",
          dealValue: "Valeur de l'affaire",
          dealClose: "Date de clôture de l'affaire",
          selectDeal: "Sélectionnez une affaire",
          recipients: "Destinataires",
          subject: "Sujet",
          message: "Message",
          meetingTitle: "Titre de la réunion",
          meetingStartDate: "Date de début",
          meetingEndDate: "Date de fin",
          meetingLocation: "Lieu",
          meetingReminder: "Rappel",
          meetingDescription: "Description",
          meetingInternalNote: "Note interne",
          low: "Basse",
          medium: "Moyenne",
          high: "Haute",
          dueDate: "Date d'échéance",
          hsTaskType: "Type de tâche",
          call: "Appel",
          email: "Courriel",
          todo: "Tâche",
          crmUpdated: "CRM mis à jour correctement",
          domain: "Domaine",
          phone: "Téléphone",
          address: "Adresse",
          audioCompanyText: "Appuyez pour enregistrer des actions sur cette entreprise",
          errorMovingDeal: "Erreur lors du déplacement de l'affaire. Veuillez réessayer plus tard.",
          selectStage: "Sélectionnez l'étape du pipeline vers laquelle vous souhaitez déplacer cette affaire.",
          moveDeal: "Déplacer vers une autre étape",
          save: "Enregistrer",
          stage: "Étape",
          amount: "Montant",
          closedate: "Date de clôture",
          createdate: "Date de création",
          audioContactText: "Appuyez pour enregistrer des actions sur ce contact",
          record: "Enregistrer",
          account: "Compte",
          recording: "Enregistrement audio en cours...",
          paused: "En pause",
          microphone: "Microphone",
          recordingCancelled: "Enregistrement annulé",
          search: "Rechercher",
          min: "min",
          sortBy: "Trier par",
          newest: "Plus récent",
          oldest: "Plus ancien",
          disconnectGmail: "Déconnecter Gmail",
          logout: "Se déconnecter",
          connectGmail: "Connecter Gmail",
          gmailConnected: "Gmail connecté correctement",
          gmailDisconnected: "Gmail déconnecté correctement",
          attendees: "Participants",
          properties: "Propriétés",
          select_properties: "Sélectionnez les propriétés",
          propertyToUpdate: "Propriété à mettre à jour",
          selectProperty: "Sélectionnez les propriétés",
          updateProperties: "Mettre à jour les propriétés",
          propertiesUpdated: "Propriétés mises à jour correctement",
          propertiesUpdatedError: "Erreur lors de la mise à jour des propriétés",
          createGoogleMeet: "Envoyer le lien Google Meet",
          createMeeting: "Envoyer l'invitation de réunion au client",
          completed: "Terminé",
          not_started: "Non commencé",
          none: "Sans priorité",
          reminders: "Rappels",
          nearest: "Plus proche",
          farthest: "Plus éloigné",
          updateTask: "Mettre à jour la tâche",
          status: "Statut",
          notStarted: "Non commencé",
          inProgress: "En cours",
          errorUpdatingTask: "Erreur lors de la mise à jour de la tâche",
          priority: "Priorité",
          type: "Type",
          identifyingActions: "Identification des actions",
          welcomeToLabia: "Bienvenue sur Labia",
          onboardingDescription: "Découvrez ce que vous pouvez faire avec Labia à travers ces exemples. Cliquez sur 'Essayer' pour voir comment cela fonctionne !",
          example: "Exemple",
          tryIt: "Essayer",
          showMore: "Afficher plus",
          showLess: "Afficher moins",
          learnToUseLabia: "Cliquez ici",
          onboarding: "Voulez-vous apprendre à utiliser Labia ?",
          onboardingExamples: {
            contactAndCompany: {
              title: "Créer des Contacts et des Entreprises",
              description: "Créez facilement de nouveaux contacts et entreprises avec tous leurs détails en langage naturel.",
              example: "Labia, créez un contact nommé Daniel Rodriguez de l'entreprise Labia avec l'email dani@labia.pro et le téléphone 678368027. Créez l'entreprise Labia avec le domaine labia.pro",
            },
            dealsPipeline: {
              title: "Créer des Affaires dans le pipeline de vente",
              description: "Créez des affaires dans le pipeline de vente pour suivre les informations importantes.",
              example: "Créez une affaire d'une valeur de 5000 euros avec le nom \"Pack 100 unités\" et une date de clôture estimée au 20 juin.",
            },
            tasksAndNotes: {
              title: "Créer des Tâches et des Notes",
              description: "Planifiez des tâches et ajoutez des notes pour suivre les informations importantes et conclure plus de ventes.",
              example: "Recherchez le contact Daniel Rodríguez et créez une tâche pour l'appeler vendredi à 10 heures du matin pour vérifier s'il a pu voir notre catalogue et notre offre. Créez également une note interne expliquant qu'il est le directeur des achats, qu'il est cœliaque et qu'il supporte le Real Madrid."
            },
            email: {
              title: "Envoyer des emails",
              description: "Envoyez des Emails personalisés avec le ton de votre entreprise",
              example: "Envoyez un email à Daniel Rodríguez avec un ton enthousiaste disant que j'ai déjà essayé Labia, que je l'ai trouvé incroyable et qu'il me fera gagner beaucoup de temps, ajoutez des icônes."
            },
            meeting: {
              title: "Planifier des réunions",
              description: "Planifiez des réunions avec les clients et envoyez-leur l'invitation",
              example: "Planifiez une réunion avec Daniel Rodríguez pour le 15 juin à 12h dans ses bureaux de Madrid avec l'Objet : \"Réunion Démo\", où nous parlerons de notre nouveau produit."
            },
            call: {
              title: "Appels",
              description: "Enregistrez les appels avec le résumé de ce qui a été discuté avec le client",
              example: "Enregistrez un appel avec le contact Daniel Rodríguez il y a 10 minutes où nous avons parlé du devis que la concurrence lui a envoyé et il m'a dit que s'il obtient une réduction de 10%, il signera cet après-midi."
            },
            allInOne: {
              title: "Toutes les actions en une seule instruction",
              description: "Créez un contact, une tâche, une note et un email avec une seule instruction.",
              example: "Créez un contact nommé Carmen Rodriguez Pérez de l'entreprise CRM avec l'email carmen@crm.com et le téléphone 611223344. Créez l'entreprise CRM avec le domaine CRM.com\n\nCréez une tâche pour l'appeler vendredi à 10 heures du matin et lui dire que j'ai déjà augmenté mes ventes grâce à la meilleure gestion du CRM.\n\nCréez également une note interne du contact expliquant qu'elle est la directrice de l'entreprise et qu'elle est chargée de recevoir les suggestions des clients.\n\nEnfin, envoyez-lui un email avec un ton enthousiaste disant que j'ai déjà essayé son outil, que je l'ai trouvé incroyable et qu'il me fera gagner beaucoup de temps, ajoutez des icônes."
            }
          },
          audioHistory: "Historique audio",
          loading: "Chargement...",
          noAudioHistory: "Aucun historique audio disponible",
          selectCamera: "Sélectionner la caméra",
          capturePhoto: "Capturer la photo",
          capturing: "Capturé...",
          errorProcessingPhoto: "Erreur lors du traitement de la photo",
          ocrResult: "Texte détecté",
          ocr: "Scanner le document",
          businessCard: "Scanner la carte de visite"
        }
      },
      en: {
        translation: {
          noCreditsLeft: "No credits available",
          login: "Login",
          sendingData: "Sending data",
          notObjectProcessed: "The following objects could not be processed:\n",
          company: "Company",
          contact: "Contact",
          deal: "Deal",
          task: "Task",
          meeting: "Meeting",
          mail: "Mail",
          contacts: "Contacts",
          note: "Note",
          call: "Call",
          pipeline: "Pipeline",
          pipelineStages: "Stages",
          other: "Other",
          selectPipeline: "Select a pipeline",
          selectPipelineStage: "Select a stage",
          selectCompany: "Validate company data",
          selectContact: "Validate contact data",
          selectTask: "Validate task data",
          selectMeeting: "Validate meeting data",
          selectMail: "Validate mail data",
          selectNote: "Validate note data",
          selectCall: "Validate call data",
          selectDeal: "Validate deal data",
          tasks: "Tasks",
          next: "Next",
          finish: "Finish",
          cancel: "Cancel",
          cancelConfirmation: "Are you sure you want to cancel?",
          close: "Close",
          ok: "Ok",
          errorProcessingRequest: "Error processing request",
          errorProcessingRequestDescription: "Please try again.",
          processingAudio: "Processing audio",
          minutesSaved: "You saved",
          minutes: "minutes",
          savedIn: "in",
          audioSentCorrectly: "Audio sent successfully",
          retry: "Retry",
          dateTime: "Date and time",
          duration: "Duration",
          disposition: "Result",
          busy: "Busy",
          connected: "Connected",
          noResponse: "No response",
          wrongNumber: "Wrong number",
          voiceMessage: "Left voicemail",
          liveMessage: "Left live message",
          direction: "Direction",
          inbound: "INBOUND",
          outbound: "OUTBOUND",
          title: "Title",
          audioText: "Press to record",
          description: "Description",
          associations: "Associations",
          companies: "Companies",
          deals: "Deals",
          companyName: "Company name",
          companyDomain: "Company domain",
          selectCompany: "Select a company",
          createCompany: "Create company",
          errorSendingAudio: "Error sending audio",
          createCompanyDescription: "Create a new company",
          userAlreadyExists: "An error occurred, please check the data and try again",
          name: "Name",
          lastName: "Last name",
          email: "Email",
          phoneNumber: "Phone number",
          selectContact: "Select a contact",
          createContact: "Create contact",
          dealName: "Deal name",
          dealValue: "Deal value",
          dealClose: "Deal closing date",
          selectDeal: "Select a deal",
          recipients: "Recipients",
          subject: "Subject",
          message: "Message",
          meetingTitle: "Meeting title",
          meetingStartDate: "Start date",
          meetingEndDate: "End date",
          meetingLocation: "Location",
          meetingReminder: "Reminder",
          meetingDescription: "Description",
          meetingInternalNote: "Internal note",
          low: "Low",
          medium: "Medium",
          high: "High",
          dueDate: "Due date",
          hsTaskType: "Task type",
          call: "Call",
          email: "Email",
          todo: "Task",
          crmUpdated: "CRM updated successfully",
          domain: "Domain",
          phone: "Phone",
          address: "Address",
          audioCompanyText: "Press to record actions about this company",
          errorMovingDeal: "Error moving deal. Please try again later.",
          selectStage: "Select which pipeline stage you want to move this deal to.",
          moveDeal: "Move to another stage",
          save: "Save",
          stage: "Stage",
          amount: "Amount",
          closedate: "Closing date",
          createdate: "Creation date",
          audioContactText: "Press to record actions about this contact",
          record: "Record",
          account: "Account",
          recording: "Recording audio...",
          paused: "Paused",
          microphone: "Microphone",
          recordingCancelled: "Recording cancelled",
          search: "Search",
          min: "min",
          sortBy: "Sort by",
          newest: "Newest",
          oldest: "Oldest",
          disconnectGmail: "Disconnect Gmail",
          logout: "Logout",
          connectGmail: "Connect Gmail",
          gmailConnected: "Gmail connected successfully",
          gmailDisconnected: "Gmail disconnected successfully",
          attendees: "Attendees",
          properties: "Properties",
          select_properties: "Select properties",
          propertyToUpdate: "Property to update",
          selectProperty: "Select properties",
          updateProperties: "Update properties",
          propertiesUpdated: "Properties updated successfully",
          propertiesUpdatedError: "Error updating properties",
          createGoogleMeet: "Send Google Meet link",
          createMeeting: "Send meeting invitation to client",
          completed: "Completed",
          not_started: "Not started",
          none: "No priority",
          reminders: "Reminders",
          nearest: "Nearest",
          farthest: "Farthest",
          updateTask: "Update task",
          status: "Status",
          notStarted: "Not started",
          inProgress: "In progress",
          errorUpdatingTask: "Error updating task",
          priority: "Priority",
          type: "Type",
          identifyingActions: "Identifying actions",
          welcomeToLabia: "Welcome to Labia",
          onboardingDescription: "Discover what you can do with Labia through these examples. Click 'Try it' to see how it works!",
          example: "Example",
          tryIt: "Try it",
          showMore: "Show more",
          showLess: "Show less",
          learnToUseLabia: "Click here",
          onboarding: "Want to learn how to use Labia?",
          onboardingExamples: {
            contactAndCompany: {
              title: "Create Contacts and Companies",
              description: "Easily create new contacts and companies with all their details in natural language.",
              example: "Labia, create a contact named Daniel Rodriguez from the company Labia with email dani@labia.pro and phone 678368027. Create the company Labia with domain labia.pro",
            },
            dealsPipeline: {
              title: "Create Deals in the sales pipeline",
              description: "Create deals in the sales pipeline to track important information.",
              example: "Create a deal worth 5000 euros named \"Package 100 units\" with an estimated closing date of June 20th.",
            },
            tasksAndNotes: {
              title: "Create Tasks and Notes",
              description: "Schedule tasks and add notes to track important information and close more sales.",
              example: "Find contact Daniel Rodríguez and create a task to call him on Friday at 10 AM to check if he has been able to see our catalog and our offer. Also create an internal note stating that he is the purchasing director, is celiac, and supports Real Madrid."
            },
            email: {
              title: "Send emails",
              description: "Send personalized Emails with your company's tone",
              example: "Send an email to Daniel Rodríguez with an excited tone saying that I've already tried Labia, found it amazing and it will save me a lot of time, add icons."
            },
            meeting: {
              title: "Schedule meetings",
              description: "Schedule meetings with clients and send them the meeting invitation",
              example: "Schedule a meeting with Daniel Rodríguez for June 15th at 12 PM at his office in Madrid with the Subject: \"Demo Meeting\", where we will talk about our new product."
            },
            call: {
              title: "Calls",
              description: "Record calls with the summary of what was discussed with the client",
              example: "Record a call with contact Daniel Rodríguez 10 minutes ago where we talked about the quote that the competition sent him and he told me that if we give him a 10% discount he will sign it this afternoon."
            },
            allInOne: {
              title: "All actions in a single instruction",
              description: "Create a contact, task, note, and email with a single instruction.",
              example: "Create a contact named Carmen Rodriguez Pérez from the company CRM with email carmen@crm.com and phone 611223344. Create the company CRM with domain CRM.com\n\nCreate a task to call her on Friday at 10 AM and tell her that I've already increased my sales thanks to better CRM management.\n\nAlso create an internal note about the contact explaining that she is the company director and is in charge of receiving customer suggestions.\n\nFinally, send her an email with an excited tone saying that I've already tried her tool, found it amazing and it will save me a lot of time, add icons."
            }
          },
          audioHistory: "Audio history",
          loading: "Loading...",
          noAudioHistory: "No audio history available",
          selectCamera: "Select camera",
          capturePhoto: "Capture photo",
          capturing: "Capturing...",
          errorProcessingPhoto: "Error processing photo",
          ocrResult: "Detected text",
          ocr: "Scan document",
          businessCard: "Scan business card"
        }
      }
    }
  });

export function getLanguage() {
  return i18n.language.split('-')[0]; // Returns just the ISO-639-1 part (e.g. 'es' from 'es-ES')
}

export default i18n;